export default "__VITE_ASSET__DkIuGqZ___"